import { motion } from "framer-motion";
import { Instagram } from "lucide-react";

const INSTAGRAM_URL = "https://www.instagram.com/";

const POSTS = [
  { image: "/assets/mockup-hero.jpg", alt: "Orange tiger tee on model" },
  { image: "/assets/mockup-6.jpg", alt: "Light blue Tiger hoodie on model" },
  { image: "/assets/mockup-1.jpg", alt: "Black tiger tee with hat" },
  { image: "/assets/mockup-4.jpg", alt: "Orange tiger tee, street fit" },
  { image: "/assets/mockup-3.jpg", alt: "Gold tiger tee on model" },
  { image: "/assets/mockup-5.jpg", alt: "Black tiger tee, teen model" },
];

export const SocialStrip = () => {
  return (
    <section data-testid="social-strip" className="border-t border-zinc-200 bg-white py-14">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-8 flex flex-wrap items-center justify-between gap-3"
        >
          <p className="flex items-center gap-3 font-body text-xs font-medium uppercase tracking-[0.3em] text-tiger">
            <span className="h-px w-8 bg-tiger" />Follow The Pack
          </p>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="instagram-follow-link"
            className="flex items-center gap-2 font-heading text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500 transition-colors hover:text-tiger"
          >
            <Instagram size={14} /> @tigerclothing
          </a>
        </motion.div>

        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
          {POSTS.map((post, i) => (
            <motion.a
              key={post.image}
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noreferrer"
              data-testid={`instagram-post-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.45, delay: i * 0.07 }}
              className="group relative block aspect-square overflow-hidden border border-zinc-200"
            >
              <img
                src={post.image}
                alt={post.alt}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute inset-0 flex items-center justify-center bg-ink/0 transition-colors duration-300 group-hover:bg-ink/50">
                <Instagram size={26} className="text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
              </span>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};
